export const LogOutSvg = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.005 0C12.555 0 13 0.448 13 1V15C13 15.552 12.554 16 12.005 16H2.05C1.91894 15.9997 1.78922 15.9737 1.66823 15.9233C1.54725 15.8729 1.43738 15.7991 1.34489 15.7063C1.25241 15.6134 1.17911 15.5033 1.1292 15.3821C1.07929 15.2609 1.05374 15.1311 1.054 15V12H2.577V14.47H11.536V1.47H2.578V4H1.055V1C1.055 0.448 1.501 0 2.051 0H12.005ZM5.007 2.97L6.062 4.03L3.106 7H10.014V9H3.106L6.062 11.97L5.007 13.03L0 8L5.007 2.97Z"
        fill="currentColor"
      />
    </svg>
  );
};
